import React from 'react';
import { edocketObjectType } from './edocketObjectType';
import Section from './partials/Section';
import { dateToString, timeToString } from '../../utils/dates';

export default class History extends React.Component {
    formatDateTime(dateString) {
        const date = new Date(dateString);
        return `${dateToString(date)}, ${timeToString(date)}`;
    }

    render() {
        const history = this.props.edocket.HistoryItems;

        if (history.length === 0) {
            return <div className="edocket-tab-history">Nothing to show</div>;
        }

        return (
            <div className="edocket-tab-history">
                <Section caption="Docket history">
                    <div className="edocket-tabs-history-rows">
                        {history.map((item, index) => (
                            /* eslint-disable-next-line react/no-array-index-key */
                            <div className="history-row" key={index}>
                                <div className="history-row-date">
                                    <div className="history-row-label">
                                        Date / Time
                                    </div>
                                    <div className="history-row-value">
                                        {this.formatDateTime(item.HistoryDateTime)}
                                    </div>
                                </div>
                                {item.HistoryCreatedBy && (
                                    <div className="history-row-author">
                                        <div className="history-row-label">
                                            Created By
                                        </div>
                                        <div className="history-row-value">
                                            {item.HistoryCreatedBy}
                                        </div>
                                    </div>
                                )}
                                <div className="history-row-details">
                                    <div className="history-row-label">
                                        Details
                                    </div>
                                    <div className="history-row-value">
                                        {item.HistoryDescription}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Section>
            </div>
        );
    }
}

History.propTypes = { edocket: edocketObjectType.isRequired };
